import * as z from 'zod'

import { api } from '../../utils/api'

const InputSchema = z.tuple([z.object({
	username: z.string().nonempty()
})])

const OutputSchema = z.promise(z.string().url())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const GetPictureUploadURL = FunctionSchema.implement(async ({ username }) => await api.get(`/user/${username}/picture/uploadURL`))